import React from 'react';

import { Link } from 'formlabs-web-components/Link';
import MenuSignIn from './MenuSignIn';
import StoreButton from '../storefront/MenuButton';

import './HeaderMenu.module.css';

const MenuItem = ({
  hoverOptions,
  itemIndex,
  dropdownOpen,
  menuItem,
  handleHoverMenu,
  itemType,
  storePage,
  typeColor
}) => {
  return !menuItem || menuItem.visible ? (
    <div
      styleName={`${
        hoverOptions === itemIndex && dropdownOpen ? 'has-dropdown' : ''
      } main-menu-item`}
      key={`main-menu-div-${itemIndex}`}
    >
      {itemType === 'left' && (
        <Link
          to={menuItem.url}
          styleName="top-level-menu"
          openInNewWindow={menuItem.newWindow}
          onMouseEnter={() => handleHoverMenu(itemIndex)}
        >
          {menuItem.name}
        </Link>
      )}
      {itemType === 'right' && (
        <Link
          to={menuItem.url}
          styleName="top-level-menu"
          key={`${menuItem.url} ${menuItem.name}`}
        >
          {menuItem.name}
        </Link>
      )}
      {itemType === 'MenuSignIn' && (
        <MenuSignIn typeColor={dropdownOpen ? 'black' : typeColor} />
      )}
      {itemType === 'StoreButton' && storePage && <StoreButton />}
    </div>
  ) : null;
};

export default MenuItem;
